import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * EnvironmentSelector - Placeholder for future Environments feature
 *
 * TODO: Backend environment switching not yet implemented.
 * This component will allow users to switch between Production, Staging, etc.
 * For now, it's displayed but disabled to indicate the future feature.
 */
export function EnvironmentSelector() {
  const currentEnvironment = "Production";
  const environments = ["Production", "Staging"];

  return (
    <TooltipProvider>
      <Tooltip delayDuration={200}>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-1 opacity-50 cursor-not-allowed">
            <Button
              variant="ghost"
              disabled
              className="px-3 py-2 h-auto text-sm font-semibold cursor-not-allowed"
            >
              {currentEnvironment}
            </Button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="ghost"
                  size="sm"
                  className="h-auto p-1 cursor-not-allowed"
                  disabled
                >
                  <ChevronDown className="h-4 w-4 opacity-50" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="w-[200px]">
                {environments.map((env) => (
                  <DropdownMenuItem key={env} disabled>
                    {env}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <p>Environment switching coming soon</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
